import { render } from "./TransUnionGuarantor.vue?vue&type=template&id=6878c9c6"
import script from "./TransUnionGuarantor.vue?vue&type=script&lang=js"
export * from "./TransUnionGuarantor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__